import { render, staticRenderFns } from "./nsr.vue?vue&type=template&id=1529ab5e"
import script from "./nsr.vue?vue&type=script&lang=js"
export * from "./nsr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports